import {makeAutoObservable} from 'mobx';
import GradebookRepository from '../../../../../data/repositories/GradebookRepository';
import {toast} from 'react-toastify';
import {getErrorFromCode} from '../../../../../data/errorCodes';
import {toastConfig} from '../../../../../uiToolkit/Toast/toastConfig';

class CourseAnalyticsLearnersStore {
  private gradebookRepo = new GradebookRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getCourseLearnersData(
    organizationId: string,
    courseId: string,
    sortBy?: string,
    orderAsc?: boolean,
  ) {
    const result = await this.gradebookRepo.getCourseLearnersAnalytics(
      organizationId,
      courseId,
      sortBy,
      orderAsc,
    );
    if (result.success && result.data) {
      return result.data;
    } else if (result.errors && result.errors[0]) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
      return [];
    }
    return [];
  }

  public async getCourseLearnerAnalyticsDetails(
    organizationId: string,
    courseId: string,
    learnerId: string,
  ) {
    const result = await this.gradebookRepo.getCourseLearnerAnalyticsDetails(
      organizationId,
      courseId,
      learnerId,
    );
    if (result.success && result.data) {
      return result.data;
    } else if (result.errors && result.errors[0]) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
  }
}

export default CourseAnalyticsLearnersStore;
